import { memberAsMemberQueryKeys } from "@gymflow/api";
import {
  CurrentSubscriptionDTO,
  SubscriptionMembershipChangeDatesDTO,
} from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import { FormSelectInput } from "apps/portal/src/components/atoms";
import { useClubSettings } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { ChangeMembershipFormValues } from "../types";

export type FormScheduledDateAsMemberSelectProps = {
  activeMembership: CurrentSubscriptionDTO;
};

export const FormScheduledDateAsMemberSelect = ({
  activeMembership,
}: FormScheduledDateAsMemberSelectProps) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { club } = useClubSettings();
  return (
    <FormSelectInput<ChangeMembershipFormValues, string>
      name="date"
      label={t("page.hostedPagesProfileChangeMembership.form.date")}
      isMulti={false}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey:
            memberAsMemberQueryKeys.subscriptionChangeCalculateScheduleDates({
              subscriptionId: activeMembership.id,
            }),
          queryFn: async () =>
            (
              await api.profileApi.subscriptionChangeCalculateScheduleDates({
                subscriptionId: activeMembership.id,
              })
            ).data,
          select: (data) => {
            const { pageParams, pages } =
              data as InfiniteData<SubscriptionMembershipChangeDatesDTO>;
            const transformedPages = pages.map(({ changeDates }) =>
              changeDates.map((item, index) => ({
                id: `${item}-${index}`,
                label: DateTime.fromISO(item)
                  .setZone(club.timezone)
                  .toLocaleString(DateTime.DATE_MED),
                value: item,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          getNextPageParam: () => undefined,
          initialPageParam: undefined,
        })
      }
    />
  );
};
